import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { Subscription } from "../../Graphql/types/subscription";

export interface SubscriptionState {
  subscriptionList: Subscription[];
  subscriptionDetail: Subscription | null;
}

export const initialSubscriptionState: SubscriptionState = {
  subscriptionList: [],
  subscriptionDetail: null,
};

export const subscriptionSlice = createSlice({
  name: "subscriptions",
  initialState: initialSubscriptionState,
  reducers: {
    setSubscriptionList: (state, action: PayloadAction<Subscription[]>) => {
      state.subscriptionList = action.payload;
    },
    resetSubscriptionList: (state) => {
      state.subscriptionList = initialSubscriptionState.subscriptionList;
    },
    setSubscriptionDetail: (
      state,
      action: PayloadAction<Subscription | null>,
    ) => {
      state.subscriptionDetail = action.payload;
    },
    resetSubscriptionDetail: (state) => {
      state.subscriptionDetail = initialSubscriptionState.subscriptionDetail;
    },
  },
});

export const {
  setSubscriptionList,
  resetSubscriptionList,
  setSubscriptionDetail,
  resetSubscriptionDetail,
} = subscriptionSlice.actions;

export default subscriptionSlice.reducer;
